const DepartmentObject = {
  id: undefined,
  code: '',
  scode: '',
  name: '',
};

export default DepartmentObject;
